import * as styles from './components/styles.scss';
import { ControlIcons } from 'owa-control-icons';
import { DefaultCommand } from 'owa-timestream-asset-sdk-types';
import { registerAsset, DEFAULT_MIN_ASSET_WIDTH } from 'owa-timestream-asset-sdk';
import { tipsName, assetErrortips } from './tipStrings.locstring.json';
import loc from 'owa-localize';
import TipsView from './components/TipsView';

const TIPS_TYPE = 'tips';

export default registerAsset({
    type: TIPS_TYPE,
    iconName: ControlIcons.Lightbulb,
    unsupportedDefaultCommands: [DefaultCommand.Color, DefaultCommand.DueDate],
    getToolName: getName,
    getErrorMessage: () => loc(assetErrortips),
    viewStyle: styles.viewWrapper,
    CanvasView: TipsView,
    getAriaLabel: getName,
    getTitleString: getName,
    getSearchString: getName,
    createEmptyAsset: () => ({
        type: TIPS_TYPE,
        payload: {},
    }),
    assetResizeConfiguration: () => ({
        minWidth: DEFAULT_MIN_ASSET_WIDTH,
        defaultHeight: 340,
        minHeight: 206,
    }),
});

function getName() {
    return loc(tipsName);
}
